export default "__VITE_ASSET__B7xsi4Z___"